import { Text } from 'components';
import { PlusCircleIcon } from 'assets/svgs';

type OverviewItem = {
  title: string;
  value: string;   // 상위에서 이미 통화 포맷된 문자열 전달
  amount?: string; // 상위에서 이미 통화 포맷된 문자열 전달
  iconColor: string;
  icon: string;
  bgColor: string;
};

export const OverviewSection = ({ data }: { data: OverviewItem[] }) => {
  return (
    <div className="flex flex-col gap-2 xl:flex-row">
      <div className="flex flex-1 flex-row gap-2">
        {data.slice(0, 2).map((item, index) => (
          <div
            key={index}
            className="relative flex h-full w-full flex-col items-center justify-center gap-4 rounded-lg p-4"
          >
            <div className="pointer-events-none absolute inset-0 rounded-lg border border-[#f3f3f3]" />
            <div
              className={`flex h-12 w-12 items-center justify-center rounded-full ${
                index === 0 ? 'bg-[rgba(0,122,255,0.12)]' : 'bg-[rgba(255,149,0,0.12)]'
              }`}
            >
              <div className="flex h-5 w-5 items-center justify-center">
                {index === 0 ? (
                  <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
                    <path
                      d="M1 4.5L5 8.5L13 0.5"
                      stroke="#007AFF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <PlusCircleIcon className="h-5 w-5 [&_path]:fill-[#FF9500]" />
                )}
              </div>
            </div>
            <div className="flex flex-col items-center justify-start text-center">
              <Text size="small" weight="medium" color="secondary">
                {item.title}
              </Text>
              <Text size="heading3" weight="semibold" color="primary">
                {item.value}
              </Text>
            </div>
          </div>
        ))}
      </div>

      <div className="flex-1">
        <div className="grid grid-cols-2 gap-2">
          {data.slice(2).map((item, index) => (
            <div key={index + 2} className="relative rounded-lg">
              <div className="pointer-events-none absolute inset-0 rounded-lg border border-[#f3f3f3]" />
              <div className="flex w-full items-center justify-between p-4">
                <div className="flex flex-col items-start justify-start text-left">
                  <Text size="small" weight="medium" color="secondary">
                    {item.title}
                  </Text>
                  <Text size="heading3" weight="semibold" color="primary">
                    {item.value}
                  </Text>
                </div>
                {item.amount && (
                  <div className="flex h-6 items-center justify-center rounded-[60px] border border-zinc-600 px-2 py-1">
                    <Text size="small" weight="medium" color="secondary">
                      {item.amount}
                    </Text>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
